module.exports = __webpack_public_path__ + "static/ty-lagalo-sfe-n-q-mz-2-h-0-unsplash3x-629dfaf0553be2852612ee92342b4d8a.png";